/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_JoinInputs */



/**
* | output |
* | --- |
* | "Go to the meeting" |
*
* @param {Meeting_Notetaker_Issue_JoinInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_join = /** @type {((inputs?: Meeting_Notetaker_Issue_JoinInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_JoinInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Naar de meeting")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller à la réunion")
	return /** @type {LocalizedString} */ ("Go to the meeting")
});